import AxiosClient from "../../../services/axios.services";

class ObjectiveValueServices {
  getObjectiveValue = (params) =>
    AxiosClient.get("/api/app/evaluacion_objetivos_valores/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  getObjectiveValueById = (id) =>
    AxiosClient.get(`/api/app/evaluacion_objetivos_valores/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  saveObjectiveValue = (data) =>
    AxiosClient.post("/api/app/evaluacion_objetivos_valores/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editObjectiveValue = (id, data) =>
    AxiosClient.put(`/api/app/evaluacion_objetivos_valores/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteObjectiveValue = (id) =>
    AxiosClient.delete(`/api/app/evaluacion_objetivos_valores/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new ObjectiveValueServices();
